import React from "react";
import { useParams, useLocation } from "react-router-dom";
import AccountsList from "../Accounts/List";

/**
 * IB client trading accounts — same layout as Accounts / List (summary card, table, search),
 * without Deposit / Transfer / Withdraw summary shortcuts, without New Account, and without row Withdraw.
 * Data is loaded via fetchAgentClientAccounts(userId) inside AccountsList.
 */
const IbClientsAccounts = () => {
  const { userId } = useParams();
  const location = useLocation();
  const clientName = location.state?.clientName || "Client";

  return (
    <AccountsList
      ibAgentClientUserId={userId || null}
      hideActionColumn={Boolean(location.state?.fromClientTree)}
      hideAccountTypeSwitcher
      hideSummaryTransferWithdraw
      hideSummaryDeposit
      hideNewAccountButton
      hideRowWithdraw
      ibShowBackButton={false}
      customTitle={`You are managing ${clientName}`}
    />
  );
};

export default IbClientsAccounts;
